<template>
  <div>
    <!-- 关联周计划pc弹窗 -->
    <el-dialog title="关联周计划" :visible.sync="dialogVisible" width="50%" :before-close="handleClose" append-to-body>
      <div class="main-content">
        <div class="filter-line">
          <span class="title">周计划:</span>
          <el-select
            style="width: 70%"
            v-model="planId"
            placeholder="请选择"
            filterable
            @change="handleChange"
            popperClass="week-plan-select"
          >
            <el-option v-for="item in planIdOptions" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <el-table :data="detailList" style="width: 100%" header-cell-class-name="table-header">
          <el-table-column prop="visitDay" label="拜访日期" width="180" align="center"> </el-table-column>
          <el-table-column prop="schoolName" label="拜访学校" width="180" align="center"> </el-table-column>
          <el-table-column prop="target" label="拜访目的" align="center"> </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button @click="handleClick(scope.row)" type="text" style="padding: 0;">关联拜访</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { findPlanListByUserId, findPlanRelListByPlanId } from "@/api/visit/index.js";
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    count: {
        type: Number,
        default: 5
    }
  },
  data() {
    return {
      planId: "",
      planIdOptions: [],
      detailList: [],
    };
  },
  watch: {
    dialogVisible(val) {
        if (val) {
            this.findPlanListByUserIdApi();
        }
    }
  },
  methods: {
    // 关联拜访
    handleClick(row) {
      this.$emit("relatedData", row);
      this.handleClose();
    },
    handleChange(val) {
      findPlanRelListByPlanId({ planId: val })
        .then((res) => {
          this.detailList = res.data;
        })
        .catch((err) => {
          this.detailList = [];
          this.$MessageBox.MessageWarning(err.data.msg);
        });
    },
    findPlanListByUserIdApi() {
      findPlanListByUserId({ count: this.count })
        .then((res) => {
          this.planIdOptions = res.data;
        })
        .catch((err) => {
          this.$MessageBox.MessageWarning(err.data.msg);
        });
    },
    handleClose() {
      this.$emit("update:dialogVisible", false);
    },
  },
};
</script>
<style lang="scss" scoped>
.main-content {
  padding: 0 2rem 3rem;
  .filter-line {
    display: flex;
    align-items: center;
    margin-bottom: 1rem;
    .title {
      color: #000;
      font-size: 1rem;
      margin-right: 0.5rem;
    }
  }
}
</style>
<style lang="scss">
.table-header {
  color: rgba(0, 0, 0, 0.9) !important;
}
.week-plan-select{
  max-width: 42%;
}
</style>
